import { MAP_TENANT_FIRST_CODE, TENANT_ENV } from "./tenants";

/*
 * @Autor: chengyan9
 * @Date: 2024-08-27 15:04:44
 * @LastEditors: chengyan9
 * @LastEditTime: 2024-09-18 16:55:16
 * @Description:
 */
export interface Flow {
    sort?: number;
    index?: string | number;
    title?: string;
    name?: string;
    label?: string;
    key?: string;
    url?: string;
    icon?: string;
    subMenu?: Flow[];
    children?: Flow[];

    [key: string]: any;
}

export const getFlow = (tenantCode: any): Flow[] => {
    return [
        tenantCode === MAP_TENANT_FIRST_CODE[TENANT_ENV.JDDJ]
            ? {
                title: "首页",
                key: "workbench",
                icon: "HomeOutlined",
                url: "",
                sort: 0,
            }
            : {
                title: "门户",
                key: "home",
                url: "/home",
                icon: "HomeOutlined",
                sort: 0,
            },
        {
            title: "数据中心",
            key: "dataCenter",
            icon: "HomeOutlined",
            url: "",
            subMenu: [],
            sort: 12,
        },
        {
            title: "工单中心",
            key: "workOrder",
            icon: "HomeOutlined",
            url: "",
            sort: 10,
        },
        {
            title: "人员管理",
            key: "staff",
            icon: "HomeOutlined",
            url: "",
            subMenu: [],
            sort: 1,
        },
        {
            title: "考核管理",
            key: "assess",
            icon: "HomeOutlined",
            url: "",
            subMenu: [],
            sort: 2,
        },
        {
            title: "线索管理",
            key: "clue",
            icon: "HomeOutlined",
            url: "",
            subMenu: [],
            sort: 3,
        },
        {
            title: "外卖拓供",
            key: "takeout",
            icon: "HomeOutlined",
            url: "",
            sort: 11,
        },
        {
            title: "客户管理",
            key: "customer",
            icon: "HomeOutlined",
            url: "",
            subMenu: [],
            sort: 4,
        },
        {
            title: "拜访管理",
            key: "visit",
            icon: "HomeOutlined",
            url: "",
            subMenu: [],
            sort: 5,
        },
        {
            title: "营销管理",
            key: "sale",
            icon: "HomeOutlined",
            url: "",
            subMenu: [],
            sort: 6,
        },
        {
            title: "工具管理",
            key: "tool",
            icon: "HomeOutlined",
            url: "",
            subMenu: [],
            sort: 7,
        },
        {
            title: "数据管理",
            key: "data",
            icon: "HomeOutlined",
            url: "",
            subMenu: [],
            sort: 8,
        },
        {
            title: "过程管理",
            key: "course",
            icon: "HomeOutlined",
            url: "",
            subMenu: [],
            sort: 9,
        },
    ].filter(Boolean);
};
